import { useContext, useCallback } from 'react';
import { ModalManagerStateContext, ModalManagerSetContext } from '../../context/ModalManager';
export function useModalManager(key) {
    const modals = useContext(ModalManagerStateContext);
    if (modals === undefined) {
        throw new Error('useModalManager must be used within a ModalManagerProvider');
    }
    const setModals = useContext(ModalManagerSetContext);
    const openModal = useCallback((data = {}) => {
        setModals((prevModals) => ({ ...prevModals, [key]: data }));
    }, [key, setModals]);
    const closeModal = useCallback(() => {
        openModal(null);
    }, [openModal]);
    const modalData = modals[key];
    return {
        modalData: modalData,
        openModal,
        closeModal,
    };
}
